/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_SummaryInputs */

const en_public_docs_summary = /** @type {(inputs: Public_Docs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_public_docs_summary = /** @type {(inputs: Public_Docs_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Public_Docs_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_summary = /** @type {((inputs?: Public_Docs_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_summary(inputs)
	return en_public_docs_summary(inputs)
});